<template>
  <div class="right-panel" @click.stop>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="文字" name="1">
        <attr-text v-if="item && item.type === 'text'" :tplData="tplData" v-model="item"
                   class="panel-item"></attr-text>
        <div class="commons c-center" v-else>
          <p class="noResult c-center" style="margin-top: 40px">
            <img src="img/noResult.png">
          <p class="c-gray">请选择文字</p>
        </div>
      </el-tab-pane>
      <el-tab-pane label="素材" name="2">
        <attr-multi-material v-if="multiItems.length > 0" @onExtendImg="onExtendImg" :tplData="tplData"
                             :dataList="multiItems" class="panel-item"></attr-multi-material>
        <attr-material v-else-if="item && item.type === 'img'" @onExtendImg="onExtendImg" :tplData="tplData"
                       v-model="item" class="panel-item"></attr-material>
        <div class="commons c-center" v-else>
          <p class="noResult c-center" style="margin-top: 40px">
            <img src="img/noResult.png">
          <p class="c-gray">请选择素材</p>
        </div>
      </el-tab-pane>
      <el-tab-pane label="模块组" name="3" v-if="moduleGroupVisible">
        <attr-module v-if="tplData.id" v-model="tplData" :tplModules="tplModules" @onItemClick="onItemClick"
                     class="panel-item"></attr-module>
      </el-tab-pane>
    </el-tabs>
    <div class="c-popo-box">
      <a target="_blank"
         href="http://popo.netease.com/static/html/open_popo.html?ssid=grp.zhitu@corp.netease.com&sstp=0"
         class="popo-tools">
        <img src="/img/popo.png" height="32"/>联系我们</a>
    </div>
  </div>
</template>
<script>
    import attrMaterial from './attr-material';
    import attrMultiMaterial from './attr-multi-material'
    import attrText from './attr-text'
    import attrModule from './attr-module'
    import {template_type_single} from '@/const.js';

    export default {
        components: {attrMaterial, attrText, attrModule, attrMultiMaterial},
        props: {
            tplData: Object,
            tplModules: Array,
            global: Boolean // 模块组设置时使用
        },
        data() {
            return {};
        },
        computed: {
            moduleGroupVisible() {
                let notSingleTpl = this.tplData.type !== template_type_single;
                return notSingleTpl && this.tplModules.length > 0 && !this.global;
            },
            activeName: {
                get() {
                    return this.$store.state.templateGroup.attrActiveName;
                },
                set(v) {
                    this.$store.commit("templateGroup/set_attr_tab", v);
                }
            },
            item: {
                get() {
                    return this.$store.state.templateGroup.selectedItem;
                },
                set(item) {
                    this.$store.commit("templateGroup/set_selected_item", item);
                }
            },
            multiItems() {
                return this.$store.state.templateGroup.multiImgItems;
            }
        },
        methods: {
            onItemClick(item) {
                this.$emit('onItemClick', item);
            },
            onExtendImg(value) {
                this.$emit('onExtendImg', value)
            },
        }
    }
</script>
<style lang="scss">
  @import "right-panel";
</style>